import React from 'react'
import {initState} from './state';
export const StateContext = React.createContext({
    state: {
        ...initState
    },
    dispatch: (parms:any) => {}
})
